import type { FC, ReactNode } from "react";
import { ExclamationTriangleIcon } from "@heroicons/react/24/solid";
import { cn } from "@/lib/cn";

type InfoCardProps = {
  title: ReactNode;
  description: ReactNode;
  className?: string;
};

export const InfoCard: FC<InfoCardProps> = ({ title, description, className }) => (
  <div className={cn("flex items-center gap-16 rounded-medium bg-error-bg p-16", className)}>
    <div className="flex shrink-0 items-center justify-center rounded-medium bg-brand-red p-10">
      <ExclamationTriangleIcon className="size-32 text-neutral-white" />
    </div>
    <div className="space-y-4">
      <p className="w-full text-18 font-medium leading-[1.4] text-neutral-black">{title}</p>
      <p className="w-full text-14 leading-[1.4] text-neutral-black/70">{description}</p>
    </div>
  </div>
);
